<div class="item" *ngFor="let item of items">
    <span class="item-name"
          matTooltip="{{item.id}}: {{item.name}}"
          matTooltipPosition="above"
          [matTooltipDisabled]="!isGoFast"
    >{{item.name}}</span><span>{{item.price / 100 | customCurrency}}</span>
</div>
